import { useCallback, useEffect } from 'react';
import storeActions from '../actions';
import storeSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';
import { IApiGetListScreensInStoreParam } from 'modules/store/interfaces/api';

const useGetScreensInStore = (storeId: string, isLazy = false) => {
  const dispatch = useAppDispatch();
  const screensListInStore = storeSelectors.getScreenListInStore();
  const screenListInStoreParam = storeSelectors.getScreenListInStoreParam();

  const mutate = useCallback((params: IApiGetListScreensInStoreParam) => {
      dispatch(storeActions.getListScreensInStore.fetch({ ...params, storeId }));
    },
    [dispatch, storeId]
  );

  useEffect(() => {
    if (!isLazy) {
      mutate({
        page: 1,
        size: 10,
      });
    }
  }, [mutate, isLazy]);

  return {
    screensListInStore,
    screenListInStoreParam,
    mutate,
  };
};

export default useGetScreensInStore;
